export default "__VITE_ASSET__C02Lq4$n__"